import { render } from "./OrderShipments.vue?vue&type=template&id=651df166"
import script from "./OrderShipments.vue?vue&type=script&lang=js"
export * from "./OrderShipments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__